// extracted by mini-css-extract-plugin
export default {"wrapper":"BenefitsGrid_wrapper__NvNWO","card":"BenefitsGrid_card__1bGUQ","icon":"BenefitsGrid_icon__OwcHm","title":"BenefitsGrid_title__MaHHV","text":"BenefitsGrid_text__NRVuB"};